import {
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
} from 'react';
import { DrawerContainer, DrawerContent, Overlay } from './styles';

interface DrawerProps {
  children: ReactNode;
  openDrawer: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
}

export function Drawer({ children, openDrawer, onClose }: DrawerProps) {
  useEffect(() => {
    function onKeyup(e) {
      if (e.key === 'Escape') {
        onClose(false);
      }
    }
    window.addEventListener('keyup', onKeyup);
    return () => window.removeEventListener('keyup', onKeyup);
  }, []);
  return (
    <>
      <DrawerContainer open={openDrawer}>
        <DrawerContent>{children}</DrawerContent>
      </DrawerContainer>
      <Overlay open={openDrawer} onClick={() => onClose(!openDrawer)} />
    </>
  );
}
